const mediaData = [
  {
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20scene%20of%20a%20couple%20embracing%20on%20a%20beach%20at%20sunset%2C%20dramatic%20golden%20sky%2C%20soft%20waves%2C%20film%20grain%20texture%2C%20movie%20trailer%20style%20photography%2C%20romantic%20atmosphere%2C%20warm%20terracotta%20and%20cream%20tones%2C%20letterbox%20format%2C%20cinematic%20quality&width=800&height=450&seq=media-01-trailer&orientation=landscape',
    title: '《你比星光美丽》精彩片段',
    tag: '国产剧',
    duration: '03:25',
    views: '128万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20Korean%20drama%20scene%20of%20a%20couple%20in%20the%20rain%20under%20a%20shared%20umbrella%20on%20a%20city%20street%20at%20night%2C%20neon%20reflections%2C%20romantic%20cinematic%20composition%2C%20film%20photography%2C%20warm%20amber%20lighting%2C%20letterbox%20format&width=800&height=450&seq=media-02-trailer&orientation=landscape',
    title: '《眼泪女王》经典名场面合集',
    tag: '韩剧',
    duration: '05:12',
    views: '96万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20epic%20fantasy%20scene%20with%20a%20couple%20in%20flowing%20ancient%20Chinese%20robes%20flying%20through%20a%20mystical%20mountain%20landscape%2C%20dramatic%20clouds%2C%20golden%20sunlight%2C%20cinematic%20film%20photography%2C%20warm%20terracotta%20tones%2C%20letterbox%20format&width=800&height=450&seq=media-03-trailer&orientation=landscape',
    title: '《与凤行》高燃预告片',
    tag: '古装剧',
    duration: '02:48',
    views: '85万',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-800 mb-3">
            精彩预告
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            热门剧集精彩片段和预告，快速了解剧情亮点
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {mediaData.map((item, idx) => (
            <a
              key={idx}
              href="#media"
              className="group bg-background-50 rounded-2xl overflow-hidden border border-secondary-200/70 transition-all hover:border-primary-200/60"
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-52 object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-white/90 flex items-center justify-center group-hover:scale-110 transition-transform shadow-lg">
                    <i className="ri-play-fill text-primary-500 text-2xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute top-3 left-3 px-2 py-0.5 rounded bg-black/40 text-white text-xs backdrop-blur-sm">
                  {item.tag}
                </span>
                <span className="absolute bottom-3 right-3 px-2 py-0.5 rounded bg-black/50 text-white text-xs backdrop-blur-sm">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-bold text-foreground-800 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span><i className="ri-eye-line mr-1"></i>{item.views} 次观看</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}